import cn from 'classnames';
import React from 'react';

import { RubricMenuSearch as RubricMenuSearchFromPackage } from '@sravni/react-ugc/lib/Search';
import { useIsMobile } from '@sravni/react-utils';

import { getPlaceholder, searchAndNavigate } from '../../helpers';

import styles from './rubric-menu-search.module.scss';

export const RubricMenuSearch = ({ toogleRubricMenu }) => {
  const isMobile = useIsMobile();

  const placeholder = getPlaceholder(isMobile);

  return (
    <RubricMenuSearchFromPackage
      onSearch={searchAndNavigate}
      toogleRubricMenu={toogleRubricMenu}
      onKeyDown={() => toogleRubricMenu}
      className={cn(styles.RubricMenuSearch)}
      placeholder={placeholder}
    />
  );
};

RubricMenuSearch.displayName = 'RubricMenuSearch';
